import { ReunionAgency, ReunionTransaction } from '../../../hooks/useReunionMensuelleData';
import MultiSelect from '../../validation/filters/MultiSelect';

export type CompanyScope = 'ALL' | 'KI' | 'KA' | 'DRYADE';

export interface Scope {
  company: CompanyScope;
  /** Liste des agences sélectionnées au sein de la société. Vide = toutes les agences. */
  agency: string[];
}

export interface ScopeColumn {
  key: string;
  label: string;
}

const COMPANY_OPTIONS: { value: CompanyScope; label: string }[] = [
  { value: 'ALL', label: 'Toutes les sociétés' },
  { value: 'KI', label: 'Kermarrec Immobilier' },
  { value: 'KA', label: 'Kermarrec Atlantique' },
  { value: 'DRYADE', label: 'Dryade' },
];

const SELECT_CLS = 'px-3 py-2 text-sm border border-slate-200 rounded-xl text-slate-700 bg-white hover:border-slate-300 focus:outline-none focus:ring-2 focus:ring-indigo-400/40 focus:border-indigo-400 transition-colors cursor-pointer';

export function getScopeColumns(scope: Scope, agencies: ReunionAgency[]): ScopeColumn[] {
  if (scope.company === 'ALL') {
    return COMPANY_OPTIONS.filter(o => o.value !== 'ALL').map(o => ({ key: o.value, label: o.label }));
  }
  const ofCompany = agencies.filter(a => a.company === scope.company);
  const filtered = scope.agency.length > 0 ? ofCompany.filter(a => scope.agency.includes(a.name)) : ofCompany;
  return filtered.map(a => ({ key: a.name, label: a.name }));
}

export function getColumnForTransaction(tx: ReunionTransaction, scope: Scope): string | null {
  if (scope.company === 'ALL') {
    return tx.company;
  }
  if (tx.company !== scope.company) return null;
  if (scope.agency.length > 0 && (!tx.agency || !scope.agency.includes(tx.agency))) return null;
  return tx.agency;
}

interface ScopeSelectorProps {
  scope: Scope;
  onChange: (scope: Scope) => void;
  agencies: ReunionAgency[];
}

export default function ScopeSelector({ scope, onChange, agencies }: ScopeSelectorProps) {
  const agencyOptions = agencies
    .filter(a => a.company === scope.company)
    .map(a => ({ value: a.name, label: a.name }));

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <select
        value={scope.company}
        onChange={(e) => onChange({ company: e.target.value as CompanyScope, agency: [] })}
        className={SELECT_CLS}
      >
        {COMPANY_OPTIONS.map(o => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>

      {scope.company !== 'ALL' && (
        <div className="w-64">
          <MultiSelect
            options={agencyOptions}
            value={scope.agency}
            onChange={(agency) => onChange({ ...scope, agency })}
            placeholder="Toutes les agences"
          />
        </div>
      )}
    </div>
  );
}
